<template>
  <v-form v-model="valid">
    <div class="display-1">{{ $t('registration.steps[2]') }}</div>
    <v-divider />
    <v-layout wrap class="my-4">
      <v-flex xs12 sm8>
        <div class="title">{{ event.name }}</div>
      </v-flex>
      <v-flex  xs6 sm2 align-content-end shrink style="text-align: right;">
        <span class="body-1">Registration Fee:</span><br>
        <span class="body-1">Taxes:</span><br>
      </v-flex>
      <v-flex xs6 sm2 align-content-end style="text-align: right;">
        <span class="body-1">{{$t('eventCard.dollarSign') + parseFloat(event.fee).toFixed(2) }}</span><br>
        <span class="body-1">{{$t('eventCard.dollarSign') + (parseFloat(event.total) - parseFloat(event.fee)).toFixed(2) }}</span><br>
        <span class="title">{{ $t('eventCard.dollarSign') + event.total }}</span>
      </v-flex>
      <v-flex xs12>
        <address>
          <span class="addr-name">{{ rink.name }}</span>
          <span class="addr-street">{{ rink.address }}</span>
          <span class="addr-area">{{ rink.city }} {{ rink.state }}, {{ rink.zip }}</span>
        </address>
      </v-flex>
      <v-flex xs12>
        {{ event.description }}
      </v-flex>
      <v-flex xs12>
        {{ eventDatetime }}
      </v-flex>
    </v-layout>
    <v-layout
      class="mt-2"
      wrap
    >
      <v-flex
        v-show="filteredEvents.length > 0"
        class="blue--text text--darken-4 pb-2 title"
        xs12
      >
        Would you like to add more events?
      </v-flex>
      <v-flex xs12 my-1>
      </v-flex>
      <v-flex
        xs12
        v-for="event in filteredEvents"
        :key="event.id"
        class="mb-1"
      >
        <v-layout wrap>
          <v-flex xs12 py-2>
            <v-divider />
          </v-flex>
          <v-flex xs12 sm6 md5>
            <span class="title">{{ event.name }}</span><br>
            <hr>
            {{ getRink(event['location-id']).name }}<br>
            {{ getRink(event['location-id']).address }},
            {{ getRink(event['location-id']).city }} {{ getRink(event['location-id']).state }}, {{ getRink(event['location-id']).zip }}<br>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <div>
              {{ viewDatetime(event['event-datetime']) }}
            </div>
            <div class="text-xs-center my-1 font-weight-medium">
              <span :class="getEventStatus(event.id).type" style="color: white; padding: .2rem .5rem;">{{ getEventStatus(event.id).status }}</span>
            </div>
          </v-flex>
          <v-spacer />
          <v-flex pt-3 pr-3 xs6 md2 shrink class="subheading font-weight-medium text-sm-right">
            ${{ event['total'] }}
          </v-flex>
          <v-spacer />
          <v-flex shrink class="text-align-right">
            <v-checkbox
              v-model="selectedEvents"
              :value="event.id"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-divider />
    <v-layout wrap my-2>
      <v-spacer />
      <v-flex xs12 sm4 class="display-1" style="text-align: right;">
        <small>TOTAL:</small> ${{ total.toFixed(2) }}
      </v-flex>
      <v-flex xs12>
        <v-divider />
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import * as date from '../../libs/js/dates'

export default {
  name: 'EventConfirmation',
  data () {
    return {
      valid: true,
      events: [],
      selectedEvents: []
    }
  },
  computed: {
    getEvent() {
      return (id) => {
        return this.$store.state.events.find(ev => ev.id === id)
      }
    },
    getRink() {
      return(id) => {
        return this.$store.state.rinks.find(rnk => rnk.id === id)
      }
    },
    getEventStatus() {
      return (id) => {
        let status = this.$store.state.events.find(ev => ev.id === id).status
        switch (status) {
          case 'active-public':
            return {type: 'info', status: 'Available Spaces'}
          case 'active-waitlist':
            return {type: 'warning', status: 'Waitlist'}
          default:
            return {type: 'error', status: 'Closed'}
        }
      }
    },
    total() {
      let t = 0
      if (this.event) {
        t = parseFloat(this.event.total)
      }
      if (this.selectedEvents.length > 0) {
        for (let i = 0;i < this.selectedEvents.length; i++) {
          t += parseFloat(this.getEvent(this.selectedEvents[i]).total)
        }
      }
      return t
    },
    filteredEvents () {
      return this.$store.state.events.filter(ev => ev.id.toString() !== this.$route.params.id.toString() && ev['nhl-season'] === this.event['nhl-season'])
    },
    event() {
      let e = this.$store.state.events.find(e => e.id.toString() === this.$route.params.id)
      if(e) return e
      else return { name: '', total: 0, description: '' }
    },
    rink() {
      if(this.event['location-id']) return this.$store.state.rinks.find(r => r.id === this.event['location-id'])
      else return { name: '', address: '', city: '', state: '', zip: '' }
    },
    hasRink() {
      return (this.event['location-id'] == true) && (this.$store.state.rinks.find(r => r.id === this.event['location-id']) == true)
    },
    hasSessions() {
      return Array.isArray(this.event.sessions) && this.event.sessions.length > 0
    },
    bdateMin() {
      return date.viewDate(this.event['bdate-min'] || this.event['nhl-bdate-min'], this.$i18n.locale)
    },
    bdateMax() {
      return date.viewDate(this.event['bdate-max'] || this.event['nhl-bdate-max'], this.$i18n.locale)
    },
    ageRestriction() {
      return this.$t('eventCard.bdateRestriction').replace('%1', this.bdateMin).replace('%2', this.bdateMax)
    },
    eventDatetime() {
      return date.viewDatetime(this.event['event-datetime'], this.$i18n.locale, this.rink.time_zone)
    },
    viewDate () {
      return (val, short) => date.viewDate(val, this.$i18n.locale, short)
    },
    viewDatetime() {
      return (val) => date.viewDatetime(val, this.$i18n.locale, this.rink.time_zone)
    },
    viewTime() {
      return (val) => date.viewTime(val, this.$i18n.locale, this.rink.time_zone)
    }
  },
  methods: {
    addEvents(){
      this.events = [
        this.$route.params.id,
        ...this.selectedEvents
      ]

      return this.events
    },
    toggleSelectedEvent(id) {
      if (this.selectedEvents.includes(id)) {
        this.selectedEvents.splice(this.selectedEvents.indexOf(id), 1)
      } else {
        this.selectedEvents.push(id)
      }
    }
  }
}
</script>

<style scoped>
address span {
  display: block;
  font-style: normal;
}
.warning, .info {
  border-radius: 8px;
}
</style>